<div class="chart">
  <div
    class="d-flex flex-wrap ms-xxl-7 py-3 fw-medium"
    *ngIf="showMeasuringPointsTotal"
  >
    <div class="col-12 col-xl-auto">
      <ng-container
        *appSkeletonLoader="loading; style: { width: '6rem', height: '2rem' }"
      >
        <span
          class="text-lowercase"
          i18n="@@common_evaluationChart_measuringPoints"
          >{{ measuringPointsTotal }} { measuringPointsTotal, plural, =0
          {realized measuring point} =1 {realized measuring point} other
          {realized measuring points}}</span
        >
      </ng-container>
    </div>
    <div class="col-12 col-xl-auto ms-xl-8" *ngIf="chartDatasetFilter">
      <ng-container
        *appSkeletonLoader="loading; style: { width: '15rem', height: '2rem' }"
      >
        <img
          src="assets/icons/icon_up.svg"
          alt="triangle"
          class="icon-triangle align-baseline me-3"
        />
        {{ chartDatasetFilter.legend }}
      </ng-container>
    </div>
  </div>
  <div class="chart__canvas">
    <ng-container
      *appSkeletonLoader="loading; style: { height: '25rem' }"
    ></ng-container>
    <div [ngClass]="{ 'd-none': loading }">
      <canvas #chartCanvas></canvas>
    </div>
    <div
      [ngClass]="{ 'd-none': loading || (!loading && !hasNoData) }"
      class="chart__canvas__no-content fw-medium bg-white text-gray-60 px-4 py-3"
    >
      <span i18n="@@common_evaluationChart_noData">No received data</span>
    </div>
  </div>
  <div
    class="chart__legend chart__legend--interactive mt-6 p-4 mx-xxl-4"
    *ngIf="hasInteractiveLegend"
  >
    <ng-container *appSkeletonLoader="loading; style: { height: '18rem' }">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12"
            [ngClass]="{
              'col-xl-6 mb-4 mb-xl-0': chartDatasetFilter !== undefined
            }"
          >
            <h4 class="text-uppercase d-flex align-items-center">
              <img src="assets/icons/icon-filters.svg" class="img-fluid me-3" />
              <span i18n="@@common_evaluationChart_customizedDisplay"
                >Customized display</span
              >
              ({{ getDisplayedDatasets() }})
            </h4>
            <div
              class="row mt-4"
              [ngClass]="{ 'row-cols-1': chartDatasetFilter !== undefined }"
            >
              <div
                [ngClass]="{
                  col: chartDatasetFilter !== undefined,
                  'col-12 col-xl-6 col-xxl-4': chartDatasetFilter === undefined
                }"
                *ngFor="let item of legend; let i = index"
              >
                <div
                  class="btn-group btn-group-toggle form-group checkbox-group"
                >
                  <div class="d-flex align-items-start">
                    <label
                      class="checkbox-form btn"
                      ngbButtonLabel
                      [class.active]="!item.hidden"
                    >
                      <input
                        type="checkbox"
                        [ngModel]="!item.hidden"
                        (ngModelChange)="toggleHideDataset($event, i)"
                        [id]="'chartDatasetFilter_' + i"
                      />
                      <div class="chart__legend__item">
                        <span
                          aria-hidden="false"
                          class="chart__legend__item__point"
                          [style.backgroundColor]="item.strokeStyle"
                        ></span>
                        {{ getLegendLabel(item) }}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6" *ngIf="chartDatasetFilter !== undefined">
            <h4 class="text-uppercase d-flex align-items-center">
              <img src="assets/icons/icon-filters.svg" class="img-fluid me-3" />
              {{ chartDatasetFilter.title }}
            </h4>
            <div class="row mt-4 row-cols-1">
              <div
                class="col"
                *ngFor="let option of chartDatasetFilter.options; let i = index"
              >
                <div
                  class="btn-group btn-group-toggle form-group checkbox-group"
                  [ngClass]="{ active: chartDatasetFilter.options[i].show }"
                >
                  <div class="d-flex align-items-start">
                    <label
                      class="checkbox-form btn"
                      ngbButtonLabel
                      [class.active]="chartDatasetFilter.options[i].show"
                    >
                      <input
                        [ngModel]="chartDatasetFilter.options[i].show"
                        type="checkbox"
                        (ngModelChange)="filterByDatasetFilterOption($event, i)"
                        ngbButton
                      />
                      <div class="chart__legend__item w-75">
                        {{ option.title }}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div
    class="chart__legend chart__legend--interactive mt-6 p-4 mx-xxl-4"
    *ngIf="isPhq8"
  >
    <div class="container-fluid">
      <h4 class="text-uppercase my-4" i18n="@@common_evaluationChart_legende">
        Légende
      </h4>
      <div class="row">
        <div
          *ngFor="let legend of legends | keyvalue"
          class="col-6 mb-4 d-flex align-items-center"
        >
          <div class="{{ 'intervalBox' + legend.key }}"></div>
          <span>{{ legend.value }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
